function schedule() {
    return {
        items: [],

        get upcommingItems() {
            if (!this.items || this.items.length <= 0) return [];
            return this.items.filter(item => item.endDate * 1000 > Date.now());
        }
    };
}

window.organizationSchedule = schedule;
